import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import {
  fun_CheckLockBrand,
  fun_ECCAInit,
  fun_GetExpirationDate,
  fun_GetLockNumber,
  fun_IsIe
} from "../../../../../utils/commonLock";
// 引入转译方法
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        contractRecordDirectlyId: null, // 直接发包备案主键
        tenderReference: null, // 招标编号
        registrationId: null, // 招标登记编号
        announcementId: null, // 招标公告编号
        constructionNo: null, // 报建编号
        prjName: null, // 项目名称
        section: null, // 标段号
        tenderContent: null, // 招标内容
        tenderContentNum: null, // 招标内容编号
        tenderClassNumName: null, // 招标类别
        tenderTypeNumName: null, // 招标方式
        corpName: null, // 中标单位名称
        basicInfoId: null, // 中标单位名称编号
        personName: null, // 项目经理名称
        winningPrice: null, // 中标价（万元）
        state: null, // 状态
        stateName: null, // 状态名称
        regulators: null, // 区管代码
        regulatorsName: null, // 区管代码名称
        constructorId: null, // 项目负责人编号
        idCard: null, // 项目负责人身份证
        chageIdCard: null, // 变更后项目负责人身份证
        regLockBrand: null, // 锁品牌
        regBasicinfoChange: null, // 更换后的项目负责人主键
        basicinfoChangeName: null, // 更换后的项目经理（总监）名称
        unionPersonName: null, // 项目负责人名称
        oldLockBrand: null, // 锁品牌
        oldPersonId: null, // 旧锁负责人编号
        unionAgreementId: null, // 联合投标编号
      },
      // 表单错误
      errRules: {},
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 主键
      id: null,
      // 操作类型
      controllerFlg: null,
      // 全局加载
      fullLoading: null,
      // 历史查看标志
      historyType: null,
      // 核验表单
      auditForm: {
        id: null,
        recordNumber: null,
        state: null,
        auditType: null,
        auditContent: null,
        lockNo: null,
        digitalSignature: null,
      },
    };
  },
  // 注册组件
  components: {
    TenderPictureinfor // 附件页面
  },
  // 接收父组件传递的数据
  props: {
  
  },
  // 模板编译完成
  mounted() {
    // 获取标识
    this.controllerFlg = this.$route.query.controllerFlg;
    // 获取历史查看标志
    this.historyType = this.$route.query.historyType;
    // 获取主键
    this.auditForm.recordNumber = this.$route.query.id;
    // 核验主键
    this.auditForm.id = this.$route.query.auditId;
    // 核验类型
    this.auditForm.auditType = this.$route.query.auditType;
    // 默认调用
    this.fun_Open();
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 如果是历史查看
        if(this.historyType === 'look'){
          // 遍历
          this.formConfigList.map(item => {
            // 遍历
            item.formConfigList.map(e => {
              // 禁止输入
              e.disabled = true;
            })
          })
        }
        // 如果是核验查看
        else{
          // 遍历
          this.formConfigList.map(item => {
            // 遍历
            item.formConfigList.map(e => {
              // 不为核验备注
              if (e.value != 'auditOpinion') {
                // 禁止输入
                e.disabled = true;
              }
            })
          })
        }
        // 查看详情
        this.fun_GetDetail();
      }
    },
    /**
     * @description 详情
     * @author
     */
    fun_GetDetail() {
      // 请求，获取结果集
      fun_PostAction("/contractProjectManager/auditDetail", {
        id: this.auditForm.recordNumber
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 回显字段
      this.form[i] = e;
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 提交方法
     * @author liutong
     */
    fun_Audit(state) {
      // 遍历
      this.formConfigList.map(val=>{
        val.formConfigList.map(e=>{
          // 判断是否为核验
          if(e.value === "auditOpinion"){
            // 取消验证
            e.rule[0].required = state === 'tg' ? false : true;
          }
        })
      })
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 判断验证
        if(valid){
          // 状态
          this.auditForm.state = state;
          // 提交的方法
          this.fun_Submit();
        }else{
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
        }
      })
    },
    /**
     * 核验操做
     */
    fun_Submit() {
      // 提示
      let msg = this.auditForm.state === "tg" ? "通过" : "退回";
      // 弹出询问confirm
      this.$confirm("是否确定核验" + msg + "？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 打开遮罩
        this.fun_Loading();
        // 核验意见
        this.auditForm.auditContent = this.form.auditOpinion;
        // 发起请求
        fun_PostAction("/auditProcess/audit", this.auditForm).then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.$router.back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
        });
      }).catch(err => {
        console.log(err);
      })
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
  }
};
